export default "__VITE_ASSET__DEeqfxIJ__"